/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Entity_Locked_PropertyInputs */

const cs_import_entity_locked_property = /** @type {(inputs: Import_Entity_Locked_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento formát importuje pouze nemovitosti.`)
};

const en_import_entity_locked_property = /** @type {(inputs: Import_Entity_Locked_PropertyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This format imports properties only.`)
};

/**
* | output |
* | --- |
* | "This format imports properties only." |
*
* @param {Import_Entity_Locked_PropertyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_entity_locked_property = /** @type {((inputs?: Import_Entity_Locked_PropertyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Entity_Locked_PropertyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_entity_locked_property(inputs)
	return cs_import_entity_locked_property(inputs)
});